/**
 * Reporting Agent — standalone Oracle Fusion BI Publisher browser & runner.
 * Executive layout matching the EPBCS / EPM control-room design.
 */
import React from "react";
import { useParams } from "react-router-dom";
import ConnectionSection from "./ConnectionSection";
import CatalogSection from "./CatalogSection";
import QueriesSection from "./QueriesSection";
import AiSection from "./AiSection";

const SECTIONS = ["ai", "catalog", "queries", "connection"];

const TITLES = {
  ai: "Ask AI",
  catalog: "Report Catalog",
  queries: "Report Queries",
  connection: "Fusion Connection",
};

const SUBTITLES = {
  ai: "Ask for any report in plain English — the agent picks the report, fills the parameters and runs it for you.",
  catalog: "Browse the live BI Publisher catalog over SOAP — folders, reports and data models straight from your Fusion pod.",
  queries: "Index every report and data-model SQL query across the catalog in one scan, then run any report on demand.",
  connection: "One dedicated connection for the Reporting Agent — applicable across ERP, GL, AP, AR and any BI Publisher report.",
};

export default function ReportingPage() {
  const { section } = useParams();
  const active = SECTIONS.includes(section) ? section : "ai";

  return (
    <div className="flex flex-col min-h-full bg-[#F8F9FA]">
      <div className="flex-none bg-white border-b border-slate-200">
        <div className="flex flex-wrap items-center justify-between gap-3 px-6 py-4">
          <div>
            <div className="flex items-center gap-2 text-[10px] uppercase tracking-[0.2em] font-bold">
              <span className="text-[#C8A24B]">Reporting Agent</span>
              <span className="text-slate-300">/</span>
              <span className="text-slate-500">Oracle Fusion · BI Publisher</span>
            </div>
            <h1 className="mt-0.5 text-2xl font-semibold tracking-tight text-[#0F172A]" data-testid="reporting-title">
              {TITLES[active]}
            </h1>
          </div>
          <p className="hidden xl:block max-w-md text-right text-xs leading-relaxed text-slate-500">
            {SUBTITLES[active]}
          </p>
        </div>
      </div>
      <div className="flex-1 p-4 md:p-6 w-full">
        {active === "ai" && <AiSection />}
        {active === "catalog" && <CatalogSection />}
        {active === "queries" && <QueriesSection />}
        {active === "connection" && <ConnectionSection />}
      </div>
    </div>
  );
}
